import React from 'react';
import { Button, GBThemeWrapper, GBTypography } from '@leapfinance/geebee-component-library';
import { Tooltip } from '@mui/material';
import { convertToNormalCase } from '../../../helpers';
import SOPDashboardTableDocumentsView from './SOPDashboardTableDocumentsView';
import SOPStatusChip from './SOPStatusChip';
var TableHeader = function (_a) {
    var headerName = _a.headerName;
    return (React.createElement(GBTypography, { variant: "caption1Semibold", className: "lfc-text-grey-800 lfc-h-auto lfc-whitespace-normal" }, headerName));
};
var TableContent = function (_a) {
    var content = _a.content;
    if (typeof window === 'undefined')
        return null;
    return (React.createElement(GBThemeWrapper, null,
        React.createElement(Tooltip, { title: content, arrow: true },
            React.createElement("div", null,
                React.createElement(GBTypography, { variant: "body4", className: "lfc-line-clamp-3 lfc-break-words" }, content)))));
};
export var getSOPDashboardTableColumns = function (source) {
    var columns = [
        {
            field: 'id',
            headerName: 'Request Id',
            flex: 0.7,
            minWidth: 100,
            sortable: false,
            headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
            renderHeader: function (params) {
                var _a;
                return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
            },
            renderCell: function (params) {
                var _a;
                return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-items-center lfc-px-1 lfc-py-4" },
                    React.createElement(TableContent, { content: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.id })));
            }
        },
        {
            field: 'studentName',
            headerName: 'Student',
            minWidth: 150,
            flex: 1,
            sortable: false,
            headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
            renderHeader: function (params) {
                var _a;
                return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
            },
            renderCell: function (params) {
                var _a, _b;
                return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-justify-center lfc-flex-col lfc-gap-1 lfc-px-1 lfc-py-4" },
                    React.createElement(TableContent, { content: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.studentName }),
                    React.createElement(GBTypography, { variant: "body4", className: "lfc-text-gbTokens-grey-400 hover:lfc-underline hover:lfc-text-primary-500 lfc-cursor-pointer", onClick: function () {
                            var _a, _b, _c, _d, _e, _f;
                            if (!((_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.studentId) || !((_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 : _b.applicationId))
                                return;
                            ((_c = params === null || params === void 0 ? void 0 : params.row) === null || _c === void 0 ? void 0 : _c.source) === 'CSP'
                                ? window === null || window === void 0 ? void 0 : window.open("/profile/".concat((_d = params === null || params === void 0 ? void 0 : params.row) === null || _d === void 0 ? void 0 : _d.studentId, "?key=APPLICATIONS&applicationId=").concat((_e = params === null || params === void 0 ? void 0 : params.row) === null || _e === void 0 ? void 0 : _e.applicationId))
                                : window === null || window === void 0 ? void 0 : window.open("/student/".concat((_f = params === null || params === void 0 ? void 0 : params.row) === null || _f === void 0 ? void 0 : _f.studentId, "?active=DETAILS"));
                        } },
                        "Id: ", (_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 :
                        _b.studentId)));
            }
        },
        {
            field: 'universityName',
            headerName: 'University',
            minWidth: 200,
            flex: 1.5,
            sortable: false,
            headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
            renderHeader: function (params) {
                var _a;
                return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
            },
            renderCell: function (params) {
                var _a, _b;
                return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-items-center lfc-px-1 lfc-py-4" },
                    React.createElement(TableContent, { content: "".concat((_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.universityName, ", ").concat((_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 : _b.applicationCountry) })));
            }
        },
        {
            field: 'courseName',
            headerName: 'Course',
            minWidth: 200,
            flex: 1.5,
            sortable: false,
            headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
            renderHeader: function (params) {
                var _a;
                return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
            },
            renderCell: function (params) {
                var _a;
                return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-items-center lfc-px-1 lfc-py-4" },
                    React.createElement(TableContent, { content: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.courseName })));
            }
        },
        source === 'SPEEDUP' &&
            {
                field: 'sopOwner',
                headerName: 'SOP Owner',
                minWidth: 150,
                flex: 1,
                sortable: false,
                headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
                renderHeader: function (params) {
                    var _a;
                    return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
                },
                renderCell: function (params) {
                    var _a;
                    return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-items-center lfc-px-1 lfc-py-4" },
                        React.createElement(TableContent, { content: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.sopOwner })));
                }
            },
        {
            field: 'statusLabel',
            headerName: 'Status',
            minWidth: 200,
            flex: 1.5,
            sortable: false,
            headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
            renderHeader: function (params) {
                var _a;
                return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
            },
            renderCell: function (params) {
                var _a, _b, _c, _d;
                return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-items-center lfc-px-1 lfc-py-4" },
                    React.createElement(SOPStatusChip, { status: (_b = (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.status, statusLabel: (_d = (_c = params === null || params === void 0 ? void 0 : params.row) === null || _c === void 0 ? void 0 : _c.status) === null || _d === void 0 ? void 0 : _d.statusLabel })));
            }
        },
        {
            field: 'sopRequestType',
            headerName: 'Request Type',
            minWidth: 150,
            flex: 1,
            sortable: false,
            headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
            renderHeader: function (params) {
                var _a;
                return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
            },
            renderCell: function (params) {
                var _a, _b, _c, _d;
                return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-items-center lfc-px-1 lfc-py-4" },
                    React.createElement(TableContent, { content: (_d = (_c = (_b = (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.sopRequestType) === null || _b === void 0 ? void 0 : _b.split('_')) === null || _c === void 0 ? void 0 : _c.map(function (item, index) {
                            if (index === 0) {
                                return convertToNormalCase(item);
                            }
                            return item;
                        })) === null || _d === void 0 ? void 0 : _d.join(' ') })));
            }
        },
        {
            field: 'sopDrafts',
            headerName: 'SOP Draft',
            minWidth: 250,
            flex: 2,
            sortable: false,
            headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
            renderHeader: function (params) {
                var _a;
                return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
            },
            renderCell: function (params) {
                var _a, _b, _c;
                return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-flex-col lfc-gap-1 lfc-items-center lfc-px-1 lfc-py-4" },
                    React.createElement(SOPDashboardTableDocumentsView, { draftDocuments: (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.drafts, documentChipProps: (_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 : _b.documentChipProps, source: (_c = params === null || params === void 0 ? void 0 : params.row) === null || _c === void 0 ? void 0 : _c.source })));
            }
        }
    ];
    if (source === 'SPEEDUP') {
        columns === null || columns === void 0 ? void 0 : columns.push({
            field: 'createdAt',
            headerName: 'Request Raised On',
            minWidth: 150,
            flex: 1,
            sortable: false,
            headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
            renderHeader: function (params) {
                var _a;
                return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
            },
            renderCell: function (params) {
                var _a;
                return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-items-center lfc-px-1 lfc-py-4" },
                    React.createElement(TableContent, { content: getDocumentTimeStampInReadableFormat((_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.createdAt) })));
            }
        });
    }
    columns === null || columns === void 0 ? void 0 : columns.push({
        field: 'actions',
        headerName: 'Actions',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerClassName: 'lfc-w-full lfc-bg-[#F3F3FF] lfc-rounded-t-l lfc-border-b lfc-p-3',
        renderHeader: function (params) {
            var _a;
            return React.createElement(TableHeader, { headerName: (_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName });
        },
        renderCell: function (params) {
            return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-flex lfc-items-center lfc-px-1 lfc-py-4" },
                React.createElement(Button, { variant: "secondary", size: "small", onClick: function () { var _a, _b; return window === null || window === void 0 ? void 0 : window.open("/sop/".concat((_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.id).concat(((_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 : _b.sopRequestType) === 'VISA_SOP' ? '?type=visa' : '')); } }, "Edit Details")));
        }
    });
    return columns === null || columns === void 0 ? void 0 : columns.filter(function (field) { return !!field; });
};
export var getDocumentTimeStampInReadableFormat = function (timeStamp) {
    if (!timeStamp)
        return '';
    var uploadedTimeStamp = new Date(timeStamp);
    var uploadedDate = uploadedTimeStamp === null || uploadedTimeStamp === void 0 ? void 0 : uploadedTimeStamp.toDateString();
    var hours = String(uploadedTimeStamp === null || uploadedTimeStamp === void 0 ? void 0 : uploadedTimeStamp.getHours()).padStart(2, '0');
    var minutes = String(uploadedTimeStamp === null || uploadedTimeStamp === void 0 ? void 0 : uploadedTimeStamp.getMinutes()).padStart(2, '0');
    var uploadedTime = "".concat(hours, ":").concat(minutes);
    return "".concat(uploadedDate, " ").concat(uploadedTime);
};
export var SOPTypeOptions = [
    {
        label: 'Visa SOP',
        value: 'VISA_SOP'
    },
    {
        label: 'Application SOP',
        value: 'APPLICATION_SOP'
    }
];
//# sourceMappingURL=utils.js.map